(function(){
  /* 2h countdown per visitor: holds at 00:00:00 for 30 min after expiry, then resets to a fresh 2h */
  var el=document.getElementById('timer');
  if(el){var DUR=2*3600*1000,HOLD=30*60*1000,key='ya_sale_deadline';
    var end=parseInt(localStorage.getItem(key),10);
    if(!end||isNaN(end)){end=Date.now()+DUR;try{localStorage.setItem(key,end);}catch(e){}}
    function tick(){var now=Date.now();
      if(now>end+HOLD){end=now+DUR;try{localStorage.setItem(key,end);}catch(e){}}
      var d=end-now;if(d<0)d=0;
      var h=Math.floor(d/3.6e6),m=Math.floor(d%3.6e6/6e4),s=Math.floor(d%6e4/1000);
      el.textContent=(h<10?'0':'')+h+':'+(m<10?'0':'')+m+':'+(s<10?'0':'')+s;}
    tick();setInterval(tick,1000);}

  /* Plan toggle. Afterpay is one-time only: hidden on Subscribe & Save */
  var PLANS=['9791013179','9791045947','9791078715'];
  var P={sub:{btn:'Start My Routine · $109.95 →'},one:{btn:'Add to Cart · $134.95 →'}};
  function applyType(t){
    document.getElementById('lpBuyBtn').textContent=P[t].btn;
    document.getElementById('lpAfterpay').style.display=(t==='one')?'block':'none';
    var perks=document.getElementById('subPerks');if(perks)perks.style.display=(t==='one')?'none':'';
    var sp=document.getElementById('lpSellingPlan');
    if(t==='one'){sp.disabled=true;}
    else{sp.disabled=false;var fs=document.querySelector('.lp .plan.active .freq');sp.value=PLANS[fs?fs.selectedIndex:0]||PLANS[0];}
  }
  document.querySelectorAll('.lp .plan').forEach(function(p){p.addEventListener('click',function(){
    document.querySelectorAll('.lp .plan').forEach(function(x){x.classList.remove('active')});
    p.classList.add('active');applyType(p.getAttribute('data-type'));});});
  document.querySelectorAll('.lp .freq').forEach(function(f){f.addEventListener('change',function(){
    var sp=document.getElementById('lpSellingPlan');if(!sp.disabled)sp.value=PLANS[f.selectedIndex]||PLANS[0];});});

  /* Gallery */
  document.querySelectorAll('.lp .gal-thumbs img').forEach(function(t){t.addEventListener('click',function(){
    var m=document.getElementById('galMain');if(m)m.src=t.getAttribute('src');
    document.querySelectorAll('.lp .gal-thumbs img').forEach(function(x){x.classList.remove('active')});
    t.classList.add('active');t.scrollIntoView({behavior:'smooth',inline:'center',block:'nearest'});});});

  /* Accordions (FAQ + objections) */
  document.querySelectorAll('.lp .faq-q,.lp .obj-q').forEach(function(q){q.addEventListener('click',function(){q.parentElement.classList.toggle('open');});});

  /* Carousels + mobile dynamic height for B/A cards */
  document.querySelectorAll('.lp .car').forEach(function(c){var track=c.querySelector('.car-track');if(!track)return;
    function step(){var card=track.firstElementChild;return card?card.getBoundingClientRect().width+16:300;}
    var prev=c.querySelector('.prev'),next=c.querySelector('.next');
    if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    if(next)next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
  });

  /* Read more / Show less on before/after cards */
  document.querySelectorAll('.lp .ba-card').forEach(function(card){
    var txt=card.querySelector('.txt'),rm=card.querySelector('.rm');if(!txt||!rm)return;
    function chk(){if(!card.classList.contains('open'))rm.style.display=(txt.scrollHeight>txt.clientHeight+2)?'inline-block':'none';}
    rm.addEventListener('click',function(e){e.stopPropagation();
      var open=card.classList.toggle('open');rm.textContent=open?'Show less':'Read more';});
    setTimeout(chk,60);window.addEventListener('load',chk);});

  /* Week-4 before/after drag slider */
  var cs=document.getElementById('w4slider');
  if(cs){var bf=cs.querySelector('.cs-before'),hd=cs.querySelector('.cs-handle');
    function setP(p){p=Math.max(4,Math.min(96,p));bf.style.clipPath='inset(0 '+(100-p)+'% 0 0)';hd.style.left=p+'%';}
    function moveTo(x){var r=cs.getBoundingClientRect();setP((x-r.left)/r.width*100);}
    var drag=false;
    cs.addEventListener('pointerdown',function(e){drag=true;try{cs.setPointerCapture(e.pointerId);}catch(err){}moveTo(e.clientX);e.preventDefault();});
    cs.addEventListener('pointermove',function(e){if(drag)moveTo(e.clientX);});
    cs.addEventListener('pointerup',function(){drag=false;});
    cs.addEventListener('pointercancel',function(){drag=false;});
    setP(50);}

  /* Sticky: show after hero, hide at offer */
  var sticky=document.getElementById('stickyBar'),hero=document.querySelector('.lp .hero'),offer=document.getElementById('offer');
  if(sticky&&hero&&offer&&'IntersectionObserver' in window){
    var pastHero=false,inOffer=false;
    function upd(){sticky.classList.toggle('show',pastHero&&!inOffer);}
    new IntersectionObserver(function(es){es.forEach(function(e){pastHero=!e.isIntersecting;});upd();},{threshold:0}).observe(hero);
    new IntersectionObserver(function(es){es.forEach(function(e){inOffer=e.isIntersecting;});upd();},{threshold:0.05}).observe(offer);
  }

  /* Smooth scroll */
  document.querySelectorAll('.lp a[href="#offer"]').forEach(function(a){a.addEventListener('click',function(e){
    var t=document.getElementById('offer');if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'});}});});


  /* AJAX add to cart -> theme cart drawer (same pattern as Bar LDP) */
  var lpForm=document.getElementById('lpBuyForm');
  if(lpForm){lpForm.addEventListener('submit',function(e){
    e.preventDefault();
    var routeRoot=(window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/';
    var item={id:50972232679739,quantity:1};
    var sp=document.getElementById('lpSellingPlan');
    if(sp&&!sp.disabled&&sp.value){item.selling_plan=sp.value;}
    var btn=document.getElementById('lpBuyBtn');if(btn)btn.setAttribute('aria-busy','true');
    fetch(routeRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[item],sections:['cart-drawer']})})
      .then(function(r){return r.json();})
      .then(function(json){
        var drawer=document.querySelector('cart-drawer');
        if(json&&json.sections&&json.sections['cart-drawer']&&drawer){
          var doc1=new DOMParser().parseFromString(json.sections['cart-drawer'],'text/html');
          var fresh=doc1.querySelector('cart-drawer');
          if(fresh){drawer.innerHTML=fresh.innerHTML;}
          drawer.classList.remove('is-empty');
          var ov=drawer.querySelector('#CartDrawer-Overlay');if(ov)ov.addEventListener('click',function(){if(drawer.close)drawer.close();});
        }
        if(drawer&&typeof drawer.open==='function'){drawer.open();}
        document.dispatchEvent(new CustomEvent('cart:update'));
      })
      .catch(function(){window.location.href=routeRoot+'cart';})
      .then(function(){if(btn)btn.removeAttribute('aria-busy');});
  });}

  applyType('sub');
})();
